import Pullquote from 'components/pullquote';

// Custom on shortcode parse event callbacks.
export const onParseMap = {
  pullquote: (props) => ({
    ...props,
    extraProp: true,
  }),
};

export default {
  pullquote: Pullquote,
};
